"use client";

import { useEffect } from "react";

export const IntroHeight = () => {
	useEffect(() => {
		const intro = document.querySelector("#page-intro");
		if (intro) {
			const height = intro.getBoundingClientRect().height;
			document.documentElement.style.setProperty(
				"--intro-height",
				`${height}px`,
			);
		}
	}, []);

	return null;
};
